<template>
    <tr>
        <th>{{ subscription.id }}</th>
        <td>
            <choise :value="subscription.active" :translate="translate.choise"/>
        </td>
        <td>{{ subscription.ends_at | formatDate }}</td>
        <td>
            <select class="form-select" @change="onStatusChange(subscription.id, $event)">
                <option
                    v-for="status in statuses"
                    :value="status.value"
                    :selected="status.name === subscription.status_name"
                >
                    {{ status.name }}
                </option>
            </select>
        </td>
        <td>{{ translate[item.type] ? translate[item.type] : '-'}}</td>
        <td>{{ subscription.updated_at | formatDate }}</td>
        <td>{{ subscription.created_at | formatDate }}</td>
        <td>
            <div v-if="subscription.type !== 'free'">
                <div class="dropdown" style="margin-top: -5px;">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton6"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{ translate.extend }}
                    </button>
                    <form class="dropdown-menu p-4" aria-labelledby="dropdownMenuButton6" style="min-width: 200px">
                        <div class="mb-3">
                            <div class="input-group date datepicker subscription_date_picker">
                                <input type="text" class="form-control" ref="date">
                                <span class="input-group-text input-group-addon"><i data-feather="calendar"></i></span>
                            </div>
                        </div>
                        <button class="btn btn-primary" @click.prevent="prolongate(subscription.id)">{{ translate.extend }}</button>
                    </form>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['item', 'isTester', 'translate'],
    data() {
        return {
            subscription: this.item,
            isEditing: false,
            statuses: [
                {
                    "value": 1,
                    "name": this.translate.activity,//"Активна"
                },
                {
                    "value": 3,
                    "name": this.translate.inactive,//"Деактивирована"
                },
            ]
        }
    },
    mounted() {
    },
    methods: {
        prolongate(id) {
            if (!this.$refs.date.value) {
                return false;
            }

            let subscriptionUrl = this.isTester ? '/tester/subscriptions' : '/subscriptions';

            axios
                .post(subscriptionUrl + '/prolong', {'id': id, 'date': this.$refs.date.value})
                .then(response => (this.subscription = response.data.data))
        },
        onStatusChange(id, event) {
            let subscriptionUrl = this.isTester ? '/tester/subscriptions' : '/subscriptions';

            axios
                .post(subscriptionUrl + '/status', {'id': id, 'status': event.target.value})
                .then(response => (this.subscription = response.data.data))
        }
    }
}
</script>
